export const ExternalDesignPartial = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
